import React from "react";
import { Field } from "formik";
import { Box, FormHelperText } from "@mui/material";
import StarRateIcon from '@mui/icons-material/StarRate';

const RatingFormField = ({ name, maxStars = 5 }) => {
  return (
    <Field name={name}>
      {({ field, form }) => {
        const value = field.value || 0; 
        const error = form.errors[name] && form.touched[name];

        const handleClick = (newValue) => {
          form.setFieldValue(name, newValue);
          form.setFieldTouched(name, true);
        };

        return (
          <Box>
            <Box display="flex" justifyContent="center" gap={1}>
              {[...Array(maxStars)].map((_, index) => {
                const starValue = index + 1;
                return (
                  <Box
                   key={index}
                    onClick={() => handleClick(starValue)}
                    sx={{ cursor: "pointer" }}
                  >
                    {starValue <= value ? (
                      <StarRateIcon sx={{ color: "yellow.light", fontSize: "50px" }} />
                    ) : (
                      <StarRateIcon sx={{ color: "#ECECEC" ,fontSize: "50px" }} />
                    )}
                  </Box>
                );
              })}
            </Box>
            {error && <FormHelperText error>{form.errors[name]}</FormHelperText>}
          </Box>
        );
      }}
    </Field>
  );
};

export default RatingFormField;
